// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"478b5fb3","513":"cab549f0","703":"01187785","787":"e2f88d87"}[chunkId] + ".chunk.js";
};